import type { Category } from "@/types/services/api-types/category-types";

export function getCategoryFormValues(category?: Category) {
  return {
    name: category?.name ?? "",
  };
}
